import { Button } from '@/components/ui/button'
import { usePathHelper } from '@/hooks/usePathHelper'
import { Can } from '@/lib/casl'
import { useFormContext } from '@/lib/form-contexts'
import { Link, useParams } from '@tanstack/react-router'
import { ExternalLink } from 'lucide-react'
import {
  CUSTOMER_REVIEWS_FORM_PLACEMENT_INLINE,
  CUSTOMER_REVIEWS_FORM_PLACEMENT_MODAL,
} from './designForm.utils'
import PageAnnouncementBarLinkToggle from './PageAnnouncementBarLinkToggle'

const PREFIX = 'pages./reviews.blocks.main.0'
const reviews = (str) => `${PREFIX}.${str}`
const reviewFormPlacementOptions = [
  { id: CUSTOMER_REVIEWS_FORM_PLACEMENT_INLINE, name: 'Inline Form' },
  { id: CUSTOMER_REVIEWS_FORM_PLACEMENT_MODAL, name: 'Modal Button' },
]

const ReviewsPageForm = () => {
  const form = useFormContext()
  const path = usePathHelper()
  const { orgId } = useParams({ strict: false })
  const manageReviewsLink =
    orgId && path.customerReviews?.index
      ? path.customerReviews.index().using({ orgId }).search({ sort: 'received_desc' })
      : null

  return (
    <div className="mb-4 flex flex-col gap-y-6">
      <PageAnnouncementBarLinkToggle pageKey="reviews" />

      {manageReviewsLink ? (
        <Can I="list" a="customer-reviews">
          <div>
            <Button asChild variant="outline" size="sm">
              <Link {...manageReviewsLink.link}>
                <ExternalLink className="size-4" aria-hidden="true" />
                Manage Reviews
              </Link>
            </Button>
          </div>
        </Can>
      ) : null}

      <form.AppField name={reviews('props.title')}>
        {(field) => (
          <field.TextInput
            label="Page Title"
            placeholder="Reviews"
            disabled={field.state.disabled}
          />
        )}
      </form.AppField>

      <form.AppField name={reviews('props.description')}>
        {(field) => (
          <field.TextareaInput
            label="Page Description"
            placeholder="Invite customers to read reviews and share their own experience."
            rows={3}
            disabled={field.state.disabled}
          />
        )}
      </form.AppField>

      <form.AppField name={reviews('props.formPlacement')}>
        {(field) => (
          <field.RadioButtonGroup
            label="Review Form"
            options={reviewFormPlacementOptions}
            size="sm"
            classNames={{
              container: 'self-start',
            }}
            disabled={field.state.disabled}
          />
        )}
      </form.AppField>
    </div>
  )
}

export default ReviewsPageForm
